<template>
<div>
    <slot />    
</div>
</template>

<script>
export default {
name: 'nitrozen-input-suffix'    
}
</script>

<style lang="less">

</style>
